import React from 'react';

const CustomStepper = ({ activeStep, setViewStep, viewStep }) => {
  const handleStep = (step) => {
    setViewStep(step)
  }
  return (
    <div className="flex justify-between items-center gap-[15px]">
      <div
        className={`min-w-[54px] h-[54px] flex justify-center items-center rounded-[50px] flex-1 ${viewStep === 0 ? "bg-primary-main/10" : ""}`}
        onClick={() => handleStep(0)}>
        <div
          className={`w-[30px] h-[30px] text-[14px] flex justify-center items-center ${activeStep >= 0 ? "bg-primary-main text-primary-contrast" : "bg-surface"} rounded-[30px] `}>1
        </div>
      </div>
      <div
        className={`w-full h-1 rounded-[34.36px] ${activeStep > 0 ? "bg-primary-main" : "bg-surface"}`}></div>
      <div
        className={`min-w-[54px] h-[54px] flex justify-center items-center rounded-[50px] ${viewStep === 1 ? "bg-primary-main/10" : ""}`}
        onClick={() => handleStep(1)}>
        <div
          className={`w-[30px] h-[30px] text-[14px] flex justify-center items-center ${activeStep >= 1 ? "bg-primary-main text-primary-contrast" : "bg-surface"} rounded-[30px] `}>2
        </div>
      </div>

      <div
        className={`w-full h-1 rounded-[34.36px] ${activeStep > 1 ? "bg-primary-main" : "bg-surface"}`}></div>

      <div
        className={`min-w-[54px] h-[54px] flex justify-center items-center rounded-[50px] ${viewStep === 2 ? "bg-primary-main/10" : ""}`}
        onClick={() => handleStep(2)}>
        <div
          className={`w-[30px] h-[30px] text-[14px] flex justify-center items-center ${activeStep >= 2 ? "bg-primary-main text-primary-contrast" : "bg-surface "} rounded-[30px] `}>3
        </div>
      </div>
    </div>
  );
};

export default CustomStepper;
